module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_about_oa-482c2d1077b4727150d668448eee5428.png";